import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authHeaderInterceptor } from './core/interceptors/auth-header.interceptor';
import { errorHandlingInterceptor } from './core/interceptors/error-handling.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LOCALE_ID } from '@angular/core';
import { ThaiDatePipe } from './shared/pipes/thai-date.pipe';
import {
  NgbDateParserFormatter,
  NgbDatepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';
import { ThaiDateFormatterService } from './core/services/thai-date-formatter/thai-date-formatter.service';
import { ThaiDatepickerService } from './core/services/thai-date-picker/thai-datepicker.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GlobalErrorHandler } from './global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [

    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([authHeaderInterceptor, errorHandlingInterceptor])
    ),
    importProvidersFrom([
      NgxSpinnerModule.forRoot({
        type: 'ball-spin',
      })
    ]),
    provideAnimations(),
    provideToastr(),
    provideAnimationsAsync(),

    { provide: LOCALE_ID, useValue: 'th-TH' },
    ThaiDatePipe,
    {
      provide: NgbDateParserFormatter,
      useClass: ThaiDateFormatterService,
    },
    { provide: NgbDatepickerI18n, useClass: ThaiDatepickerService },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
